import {Box, styled} from "@mui/material";

export default styled(Box)`
  width: 100%;
  margin: 32px 0;
  border-bottom: 1px solid #E0E0E0;
`;

